import { render, staticRenderFns } from "./AdminTools.vue?vue&type=template&id=bc5eedd6"
import script from "./AdminTools.vue?vue&type=script&lang=js"
export * from "./AdminTools.vue?vue&type=script&lang=js"
import style0 from "./AdminTools.vue?vue&type=style&index=0&id=bc5eedd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports